import { queryOptions } from '@tanstack/react-query'
import { WebsiteRead } from '@/api/dashboard'
import { websitesQueryOpts } from './websitesQueryOpts'

export const websiteLastQueryOpts = (companyId: string, gameId: string) => {
  return queryOptions({
    ...websitesQueryOpts(companyId, gameId),
    select: data => data.sort((a, b) => (a.created_at > b.created_at ? 1 : -1)).at(0) as WebsiteRead | undefined,
  })
}
